import { useRoutingContext } from "../../context/context/RoutingContext.js";
function useFormatter() {
  const data = useRoutingContext();
  return data.format;
}
export {
  useFormatter
};
//# sourceMappingURL=use-formatter.js.map
